import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import Diff from "@/pages/Diff";
import Import from "@/pages/Import";
import Traffic from "@/pages/Traffic";
import History from "@/pages/History";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { TopNav } from "@/components/TopNav";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";

function DashboardWithState() {
  const location = useLocation();
  const prefill = location.state?.imported || null;
  return <Dashboard prefill={prefill} key={prefill?.id || "empty"} />;
}

function App() {
  return (
    <div className="App noise min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <TopNav />
          <Routes>
            <Route path="/" element={<DashboardWithState />} />
            <Route path="/diff" element={<Diff />} />
            <Route path="/import" element={<Import />} />
            <Route path="/traffic" element={<Traffic />} />
            <Route path="/history" element={<History />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
